module.exports = __webpack_public_path__ + "static/assets/f52abe3937d07c29f2374f5d33487b14.png";